import Carousel from './LoginCarousel.tsx';

const LoginDiscounts = () => {
  return (
    <section className="pt-10 pb-0 bg-gray-100"> 
      {/* 1. Ajuste de Padding Lateral: 
         - Usamos un padding más generoso en móvil (px-6).
         - El padding original del contenedor, aunque no visible en el código, 
           era gestionado por la clase `container`. Añadimos `px-6` para móviles 
           y lo reseteamos a `px-4` o similar en web si fuera necesario, 
           pero la clase `container mx-auto` ya suele manejar el centrado y margen.
           Vamos a usar `px-4` como estaba, pero mejoramos la legibilidad del texto en el siguiente punto.
      */}
      <div className="container mx-auto py-10 px-4"> 
        <div className="flex flex-wrap items-center -mx-4">
          
          {/* Columna de Texto */}
          <div className="w-full md:w-1/2 px-4 mb-6 md:mb-0">
            {/* 2. Ajuste de Título Clave: 
               - Lo definimos como 'text-3xl' por defecto (mobile).
               - Lo sobrescribimos con 'md:text-4xl' para mantener el diseño web original.
               - El tamaño original del usuario era 'text-4xl'. Lo ajustamos:
            */}
            <h3 className="text-3xl md:text-4xl font-bold mb-4" >Beneficiate refiriendo:</h3>
            
            <p className="text-lg mt-4" >¿Conocés a alguien que pueda beneficiarse de nuestras soluciones?
            Por cada nuevo cliente que llegue a través tuyo, te transferimos el <strong>15%</strong> como agradecimiento cuando tu referido adquiere nuestra solución por al menos 1 cámara + 1 año.</p>
            
            <div className="flex flex-wrap -mx-4 mt-8">
              <div className="w-1/3 my-2 px-2" >
                <img src="https://via.placeholder.com/150x45/ccc/ffffff&text=IMG LOGO" alt="" className="w-full h-auto" />
              </div>
              <div className="w-1/3 my-2 px-2" >
                <img src="https://via.placeholder.com/150x45/ccc/ffffff&text=IMG LOGO" alt="" className="w-full h-auto" />
              </div>
              <div className="w-1/3 my-2 px-2" >
                <img src="https://via.placeholder.com/150x45/ccc/ffffff&text=IMG LOGO" alt="" className="w-full h-auto" />
              </div>
            </div>
          </div>
          <div className="w-full md:w-1/2 px-4">
            <Carousel />
          </div>
        </div>
      </div>
    </section>
  );
};

export default LoginDiscounts;